import { useEffect, useState } from "react";
import Search from "../../Components/Roles/Search";
import List from "../../Components/Roles/List";
import {
  Container,
  ListWrapper,
  SearchWrapper,
} from "../../Components/ContainerSoftware/ContainerElements";
import ModalAdd from "../../Components/Roles/Modals/Add";
import ModalOperations from "../../Components/Roles/Modals/Operations";
import ModalDelete from "../../Components/Roles/Modals/Delete";
import ModalUpdate from "../../Components/Roles/Modals/Update";
import axiosConfig from "../../ApiCall/axiosConfig";
import { ToastContainer, toast } from "react-toastify";
import { Slide } from "react-toastify";

const Roles = () => {
  const [detailItem, setDetailItem] = useState([]);

  const [items, setItems] = useState([]);
  const [searchItems, setSearchItems] = useState([]);

  const [lastId, setLastId] = useState();
  const [showModal, setShowModal] = useState(false);
  const [showModalOperations, setShowModalOperations] = useState(false);
  const [showModalUpdate, setShowModalUpdate] = useState(false);
  const [showModalDelete, setShowModalDelete] = useState(false);

  const [loading, setLoading] = useState(false);

  const handleOpenModal = (modal, detailItem) => {
    if (modal === "addModal") {
      setShowModal(true);
    } else if (modal === "modalOperations") {
      setShowModalOperations(true);
      console.log(detailItem);
      setDetailItem(detailItem);
    } else if (modal === "modalUpdate") {
      setShowModalUpdate(true);
      setDetailItem(detailItem);
    } else if (modal === "modalDelete") {
      setShowModalDelete(true);
    }
  };
  const handleCloseModal = (modal) => {
    if (modal === "addModal") {
      setShowModal(false);
    } else if (modal === "modalOperations") {
      setShowModalOperations(false);
    } else if (modal === "modalUpdate") {
      setShowModalUpdate(false);
    } else if (modal === "modalDelete") {
      setShowModalDelete(false);
    }
  };

  useEffect(() => {
    setLoading(true);
    async function fetchData() {
      const token = localStorage.getItem("tokenDeliveryCompanyRoysa");
      const params = new URLSearchParams([
        ["per_page", 100],
        ["page", 1],
      ]);

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        },
        params,
      };

      try {
        const companyId = localStorage.getItem("companyId");
        const { data } = await axiosConfig.get(
          "/company_role/list/" + companyId,
          config
        );
        const itemsData = data.data.data;
        setItems(itemsData);
        setSearchItems(itemsData);

        setLastId(itemsData.slice(-1)[0].id);
        setLoading(false);
      } catch (error) {
        console.log("Error fetching roles:", error);
      }
    }

    fetchData();
  }, []);
  const filter = (e) => {
    const keyword = e.target.value;
    console.log(keyword);
    if (keyword !== "") {
      let results = searchItems.filter((item) => {
        return item?.persian_title
          .toLowerCase()
          .startsWith(keyword.toLowerCase());
      });
      setItems(results);
    } else {
      setItems(searchItems);
    }
  };

  const handleAddNew = (toastId) => {
    async function fetchData() {
      const token = localStorage.getItem("tokenDeliveryCompanyRoysa");
      const params = new URLSearchParams([
        ["per_page", 100],
        ["page", 1],
      ]);

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        },
        params,
      };

      try {
        const companyId = localStorage.getItem("companyId");
        const { data } = await axiosConfig.get(
          "/company_role/list/" + companyId,
          config
        );
        const itemsData = data.data.data;
        setItems(itemsData);
        setSearchItems(itemsData);
        setLastId(itemsData.slice(-1)[0].id);
        setLoading(false);
      } catch (error) {
        console.log("Error fetching roles:", error);
      }
      toast.update(toastId, {
        render: "نقش با موفقیت ثبت شد",
        type: "success",
        isLoading: false,
        autoClose: 3000,
        closeOnClick: true,
      });
    }
    fetchData();
  };
  const handleDelete = (toastId) => {
    async function fetchData() {
      const token = localStorage.getItem("tokenDeliveryCompanyRoysa");
      const params = new URLSearchParams([
        ["per_page", 100],
        ["page", 1],
      ]);

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        },
        params,
      };

      try {
        const companyId = localStorage.getItem("companyId");
        const { data } = await axiosConfig.get(
          "/company_role/list/" + companyId,
          config
        );
        const itemsData = data.data.data;
        setItems(itemsData);
        setSearchItems(itemsData);
        setLastId(itemsData.slice(-1)[0].id);
        setLoading(false);
      } catch (error) {
        console.log("Error fetching roles:", error);
      }
      toast.update(toastId, {
        render: "نقش با موفقیت حذف شد",
        type: "success",
        isLoading: false,
        autoClose: 3000,
        closeOnClick: true,
      });
    }
    fetchData();
  };
  const handleUpdate = (toastId) => {
    async function fetchData() {
      const token = localStorage.getItem("tokenDeliveryCompanyRoysa");
      const params = new URLSearchParams([
        ["per_page", 100],
        ["page", 1],
      ]);

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        },
        params,
      };

      try {
        const companyId = localStorage.getItem("companyId");
        const { data } = await axiosConfig.get(
          "/company_role/list/" + companyId,
          config
        );
        const itemsData = data.data.data;
        setItems(itemsData);
        setSearchItems(itemsData);
        setLastId(itemsData.slice(-1)[0].id);
        setLoading(false);
      } catch (error) {
        console.log("Error fetching roles:", error);
      }
      toast.update(toastId, {
        render: "نقش با موفقیت ویرایش شد",
        type: "success",
        isLoading: false,
        autoClose: 3000,
        closeOnClick: true,
      });
    }
    fetchData();
  };

  return (
    <>
      <ToastContainer
        transition={Slide}
        className="toast-position"
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      <Container>
        <SearchWrapper>
          <Search filter={filter} />
        </SearchWrapper>
        <ListWrapper>
          {loading ? (
            <div className="loadingList">
              <div className="spinner"></div>
            </div>
          ) : (
            <List handleOpenModal={handleOpenModal} data={items} />
          )}
        </ListWrapper>
        <ModalAdd
          lastId={lastId}
          showAddModal={showModal}
          handleCloseModal={handleCloseModal}
          handleAddNew={handleAddNew}
        ></ModalAdd>
        <ModalOperations
          showModalOperations={showModalOperations}
          detailItem={detailItem}
          handleCloseModal={handleCloseModal}
          handleOpenModal={handleOpenModal}
        ></ModalOperations>
        <ModalUpdate
          lastId={lastId}
          detailItem={detailItem}
          showModalUpdate={showModalUpdate}
          handleCloseModal={handleCloseModal}
          handleUpdate={handleUpdate}
        ></ModalUpdate>
        <ModalDelete
          showModalDelete={showModalDelete}
          detailItem={detailItem}
          handleCloseModal={handleCloseModal}
          handleDelete={handleDelete}
        ></ModalDelete>
      </Container>
    </>
  );
};
export default Roles;
